<template>
    <div class="backup-codes-modal">
        <Snackbar
            v-if="showSnackbar"
            :snackbarColor="snackbarColor"
            :snackbarMessage="snackbarMessage"
            @close="closeSnackbar()"
        >
        </Snackbar>
        <confirmationDialog
        :dialogStatus="dialogStatus"
        :title="'2FA Backup Codes'"
        :eventName="'backupCodes'"
        @backupCodes="backupCodesActions"
        >
            <v-container :class="fromHeader ? 'pa-0' : 'pa-3'">
                <!-- <v-layout wrap v-if="!fromHeader">
                    <v-flex xs12>
                        <v-icon large color="green">check_circle</v-icon>
                        <p class="green--text mt-1">
                            {{ regenerate ? 'You have used all your 2FA Backup codes.. Here are new codes.' : 'Successfully Enabled 2FA' }}
                        </p>
                    </v-flex>
                </v-layout> -->
                <v-layout wrap row class="codes">
                    <v-list>
                        <v-list-tile v-for="code in backupCodes" :key="code">
                            <v-list-tile-action>
                                <v-icon color="grey">fiber_manual_record</v-icon>
                            </v-list-tile-action>
            
                            <v-list-tile-content>
                                <v-list-tile-title class="backupCodes" v-text="code"></v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-layout>
                <v-layout wrap class="actions pt-3 ma-0">
                    <v-flex xs6>
                        <span @click="download()">
                            <v-icon>get_app</v-icon>Download</span>
                    </v-flex>
                    <v-flex xs6>
                        <span @click="copy()">
                            <v-icon>{{copiedContent ? 'done' : 'content_copy'}}</v-icon>
                            {{ copiedContent ? 'Copied!' : 'Copy to clipboard'}}
                        </span>
                    </v-flex>
                    <!-- <v-flex xs5>
                        <span @click="generate(true)">
                            <v-icon>sync</v-icon>
                            Generate new recovery codes
                        </span>
                    </v-flex> -->
                </v-layout>
                <v-layout wrap class="text_element font-weight-medium">
                    <v-flex xs12><br/>
                        Write down these emergency backup codes and store it somewhere safe. If you lose your mobile device,you can use this code to bypass two-step authentication.
                    </v-flex>
                    <v-flex xs12 v-if="!fromHeader"><br/>
                        From now on, whenever you sign in to your account, you'll need to enter both your password and also an authentication code generated by Google Authenticator.
                    </v-flex>
                    <!-- <v-flex xs12><br/>
                        <u>NOTE:</u>
                        When you generate new recovery codes, you must download or print the new codes. Your old codes won't work anymore.
                    </v-flex> -->
                </v-layout>
            </v-container>
        </confirmationDialog>
    </div>
</template>
<script>
import Vue from 'vue';
import Snackbar from "./snackbar";
import {hideLoadIcon,showLoadIcon} from '../assets/utils/load.js';
import confirmationDialog from '../../epsrc/components/common/confirmationDialog';
export default {
    name: 'backup-codes-modal',
    props: {
        fromHeader: false,
        regenerate: false,
        dialogStatus: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Snackbar,
        confirmationDialog
    },
    data () {
        return {
            backupCodesPopup: true,
            backupCodes: [],
            copiedContent: false,
            showSnackbar: false,
            snackbarColor: null,
            snackbarMessage: null,
        }
    },
    created (){
        this.generate();
    },
    methods : {
        backupCodesActions(data) {
            var self = this;
            self.$emit('close');
        },
        download(){
            var self = this;
            showLoadIcon();
            self.$loading(true);
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(self.backupCodes));
            element.setAttribute('download', 'backupCodes.txt');
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
            self.hide = hideLoadIcon();
            if(!self.hide){
                this.$loading(false);
            }
        },
        copy(){
            var self = this, codesToCopy = "", copiedText = "";
            codesToCopy = document.getElementsByClassName('backupCodes');
            for(var i = 0; i < codesToCopy.length; i++) {
                copiedText += codesToCopy[i].innerText + "\n";
            }
            try {
                // Create new element
                var el = document.createElement('textarea');
                // Set value (string to be copied)
                el.value = copiedText;
                // Set non-editable to avoid focus and move outside of view
                el.setAttribute('readonly', '');
                el.style = {position: 'absolute', left: '-9999px'};
                document.body.appendChild(el);
                // Select text inside element
                el.select();
                // Copy text to clipboard
                navigator.clipboard.writeText(el.value);
                // Remove temporary element
                document.body.removeChild(el);
                self.copiedContent = true;
                setTimeout(function(){
                    self.copiedContent = false;
                },2000);
            } catch (err) {
                self.copiedContent = false;
                self.displaySnackbar('error-banner','Something went wrong, Unable to copy!');
            }
        },
        generate(newcodes){
            var self = this, url = '/settings/recovery/codes/';
            showLoadIcon();
            self.$loading(true);
            self.backupCodes = [];
            if(newcodes){
                url = '/settings/recovery/codes/regenerate';
            }
            Vue.http.get(url)
            .then((res) => {   
                if (res.data && (typeof res.data === 'string' || res.data instanceof String)) {
                    try {
                        res.data = JSON.parse(res.data)
                    } catch (e) {
                        /* Maybe the data is expected to be string, not JSON, so leave it as-is */
                    }
                }
                self.backupCodes = res.data;
                self.hide = hideLoadIcon();
                if(!self.hide){
                    self.$loading(false);
                }
                if(newcodes){
                    self.displaySnackbar('success-banner', "Successfully generated new setup of 2FA Backup Codes!");
                }
            }, (error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    self.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
			});
        },
        // Functions to display snackbar for success/error messages
        displaySnackbar(color,message){
            var self = this;
            self.showSnackbar = false;
            setTimeout(function(){
                self.showSnackbar = true;
            },100)
            self.snackbarColor = color;
            self.snackbarMessage = message;
        },
        closeSnackbar(){
            var self = this;
            self.showSnackbar = false;
            self.snackbarColor = null;
            self.snackbarMessage = null;
        },
        showLoadIcon,
        hideLoadIcon
    }
}
</script>
<style lang="scss">

.user_creation_popup_div{
    // margin: 0px !important;
    border: none !important;
    .v-card__text{
        padding-top: 0;
    }
}

.container-width {
    width: 100%;
}

.ep-container-width {
    width: 90%;
}

.actions{
    text-align: left;
    span{
        cursor: pointer;
    }
}
.text_element {
    text-align: left;
    color: #28292B;
}
.layout.codes{
    border: 2px solid lightgrey;
    padding: 0;
    margin: 0;

    .v-list{
        width: 100%;
        max-height: 260px;
        overflow: auto;
        background-color: #EFEFEF;
    }

    .v-list__tile__action, .v-list__tile__avatar{
        min-width: 25px;
    }
}
</style>